export const fetchVersion = async (): Promise<string | null> => {
  try {
    // Append a timestamp to the URL to avoid caching
    const timestamp = new Date().getTime();
    const response = await fetch(`/version.json?timestamp=${timestamp}`);
    const data = (await response.json()) as { commit: string };

    return data.commit;
  } catch (error) {
    console.error("Failed to fetch Booking Engine version:", error);
    return null;
  }
};
